import { Button, Col, Form, Loading, Section } from 'ui';
import type { Activity } from 'models/activity';
import type { Log } from 'models/service';
import { ActivityTasksFormInput } from './features';

type P = {
  activity: Activity;
  isBookmark: boolean;
  isProgramPublished: boolean;
  loading: boolean;
  onSubmit: (taskLogs: Log[]) => Promise<void> | void;
};

const ActivityTasksForm = ({ activity, isBookmark, isProgramPublished, loading, onSubmit }: P) => {
  const [form] = Form.useForm();

  /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const onFinish = async (data: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    const cleanedTasks = data.tasks.map(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      (task: any) =>
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion, @typescript-eslint/no-unsafe-argument -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
        Object.entries(task).map(([key, value]) => {
          if (activity.tasks.some((taskOption) => taskOption.id === key && taskOption.input === 'select')) {
            return { activity_task_log: { activity_task_id: key, activity_task_option_id: String(value) } };
          }

          return { activity_task_log: { activity_task_id: key, value } };
        }) as Log[],
    );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    await onSubmit(cleanedTasks);
  };
  /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */

  return loading ? (
    <Col className="activity-task-form__loading_wrapper">
      <Loading />
    </Col>
  ) : (
    <Form form={form} initialValues={{ tasks: [{}] }} onFinish={onFinish}>
      <ActivityTasksFormInput
        isBookmark={isBookmark}
        isMultipleSubmissionsAllowed={activity.multipleSubmissions}
        name="tasks"
        tasks={activity.tasks}
      />

      {isProgramPublished ? (
        <Section lineBottom={false} lineTop={false} paddingBottom={false} paddingTop={false}>
          <Button disabled={isBookmark} htmlType="submit" type="primary">
            Submit activity
          </Button>
        </Section>
      ) : null}
    </Form>
  );
};

export default ActivityTasksForm;
